export const data = [
  {
    title: "المادة الأولى",
    content:
      " يقصد بالألفاظ والعبارات الآتية أينما وردت في هذه اللائحة المعاني الموضحة أمامها، مالم يقتض السياق خلاف ذلك: ",
    items: [
      "المركز: المركز الوطني لتنمية القطاع غير الربحي",
      "الجهات الرسمية: الجهات الحكومية ذات الصلة بالعملية المالية.",
      "الجمعية: يقصد بها جمعية تكافل لرعاية الإيتام بمنطقة المدينة المنورة تحت إشراف المركز الوطني لتنمية القطاع غير الربحي ترخيص (590)",
      "السياسة: هي سياسة خصوصية البيانات وهي هذه الوثيقة.",
      "الجمعية العمومية: أعلى جهاز في الجمعية وتتكون من مجموعة الأعضاء العاملين الذين أوفوا التزاماتهم تجاهها.",
      "المجلس: يقصد به مجلس إدارة الجمعية وهو الجهة المخولة للإشراف على أعمال الجمعية (من قبل أعضاء الجمعية العمومية) كما أنه الجهة المانحة لكافة الصلاحيات المالية والإدارية والقانونية.",
      "رئيس المجلس: يقصد به رئيس مجلس إدارة الجمعية المنتخب بواسطة مجلس الإدارة.",
      "عضو المجلس: يقصد به عضو مجلس إدارة الجمعية.",
      "الأمين العام: وهو المدير المعين من قبل مجلس الإدارة بموافقة المركز الوطني لإدارة أعمال الجمعية، وتنفيذ السياسات، والخطط الاستراتيجية، والتشغيلية.",
      "الوظائف القيادية: ويقصد بها وظيفة الأمين العام باعتباره المسؤول التنفيذي والوظائف المالية والقانونية",
      "المشمولون بالسياسة: جميع من يعمل لصالح الجمعية سواء كانوا أعضاء جمعية عمومية، أو أعضاء مجلس إدارة، أو الأمانة العامة او الوظائف القيادية، أو موظفين، أو متطوعين، أو مستشارين بصرف النظر عن مناصبهم في الجمعية، وبدون أي استثناء.",
      "صاحب الصلاحية: هو الجهة او الشخص المفوض من الجمعية العمومية أو مجلس الإدارة بصلاحية معينه حسب لائحة الصلاحيات المالية والإدارية المعتمدة في الجمعية.",
      'أصحاب المصلحة: كل من له مصلحه مع الجمعية أو مصلحة من الجمعية أو يستفيد من خدمات الجمعية أو يتأثر بمخرجاته أو نواتج أعماله " بحسب التفصيل الوارد في لائحة تعارض المصالح المعتمدة في الجمعية.',
    ],
    contact: [],
  },
  {
    title: "المادة الثانية",
    content: " تهدف هذه السياسة إلى التالي:",
    items: [
      "توضيح إجراءات التعامل مع البيانات والمحافظة على خصوصيتها داخل الجمعية",
      "تحديد الضوابط والقيود التي تلتزم بها الجمعية بخصوص البيانات التي يتم جمعها سواء كان ذلك عن طريق موظفي الجمعية فيما يخص بيانات المستفيدين أو البريد الإلكتروني أو موقع الجمعية أو غير ذلك من وسائل جمع البيانات.",
      "المحافظة على خصوصية بيانات المانحين والمتبرعين والمتطوعين والمستفيدين وعدم مشاركتها واستخدامها لأغراض الجمعية فقط وبما تقتضيه المصلحة.",
      "تحقيق متطلبات الحوكمة في الجمعيات الأهلية ومعالجة أي مخالفات قانونية ونظامية.",
    ],
    contact: [],
  },
  {
    title: "المادة الثالثة",
    content:
      "تطبق هذه السياسة على جميع المشمولين بهذه السياسة وغيرهم بصرف النظر عن مناصبهم، وكذلك أصحاب المصلحة مع الجمعية.",
    items: [],
    contact: [],
  },
  {
    title: "المادة الرابعة",
    content:
      "تشمل البيانات التي تنص عليها هذه السياسة أي بيانات عامة أو خاصة مثل البيانات الشخصية أو البريد الإلكتروني أو المراسلات أو أي بيانات أخرى تُقدَّم للجمعية سواء من المانحين أو المتبرعين أو المتطوعين أو المستفيدين من خدمات الجمعية.",
    items: [],
    contact: [],
  },
  {
    title: "المادة الخامسة",
    content: "تضمن الجمعية ما يلي:",
    items: [
      "أن تتعامل الجمعية مع بيانات المتعاملين معها بسرية تامة وألا يتم نشر أي منها ما لم يتم الحصول على موافقتهم على النشر.",
      "ألا تقوم ببيع أو مشاركة بيانات المتعاملين معها مع أي جهة أخرى دون موافقتهم.",
      "عدم إرسال أي رسائل بريد إلكتروني أو رسائل نصية للمتعاملين معها سواء بواسطتها أو بواسطة أي جهة أخرى دون موافقتهم. ",
      "ان لا تستخدم الجمعية البيانات لأي أغراض غير مهنية، وتلتزم بعدم إطلاع غير ذوي الاختصاص عليها.",
      "في حالات معينة ستتشارك الجمعية بيانات إجمالية إحصائية لا يمكن من خلالها الاستدلال على أفراد معينين وذلك للأغراض المسحية والإحصائية، او في حالات التكريم والاحتفاء بالفائزين أو المتفوقين في أنشطة الجمعية.",
      "وفي حالات استثنائية قد يطّلِع عليها من يلزم اطلاعه عليها خضوعا لأحكام القانون وأوامر الجهات القضائية.",
      "أن تنشر الجمعية سياسة خصوصية البيانات على موقعها الإلكتروني.",
      "أن يكون للجمعية سياسة بيانات خاصة بموقعها الإلكتروني.",
    ],
    contact: [],
  },
  {
    title: "المادة السادسة",
    content:
      "تشكر الجمعية كل الزائرين لموقعها على الإنترنت وتتعهد لهم بالمحافظة على خصوصية بياناتهم التي يتم تسجيلها أو تزويد الجمعية بها من خلال الموقع. كما تلتزم الجمعية بتوضيح سياستها المتعلقة بخصوصية البيانات لموقعها الالكتروني وهي كما يلي:",
    items: [
      "من حقك معرفة كيفية استخدام البيانات التي تشاركها مع موقعنا الإلكتروني.",
      "نلتزم بحماية حقوق جميع زوار ومستخدمي هذا الموقع ونلتزم بالحفاظ على سرية البيانات وقد أعددنا سياسة الخصوصية هذه للإفصاح عن النهج الذي نتبعه في جمع البيانات ونشرها على هذا الموقع الإلكتروني. ",
      "نؤكد لك أن خصوصيتك تشكل لنا أولوية كبرى، ولن نستخدم تلك البيانات إلا بالطريقة الملائمة للحفاظ على خصوصيتك بشكل آمن.",
      "نؤكد لك أيضًا أن الموقع لا يمارس أي أنشطة تجارية.",
      "لا نقوم نهائيًا بتبادل البيانات الشخصية مع أي جهة تجارية باستثناء ما يتم الإعلان عنه للمستخدم الكريم وبعد موافقته على ذلك. ",
      "لا نقوم نهائيًا باستخدام بيانات المستخدمين الكرام بإرسال رسائل ذات محتوى تجاري أو ترويجي.",
      "قد نستخدم البيانات المسجلة في الموقع لعمل الاستبانات وأخذ الآراء بهدف تطوير الموقع وتقديم تجربة استخدام أكثر سهولة وفعالية للزوار والمستخدمين الكرام. كما يمكننا من التواصل معكم عند الحاجة في حالة رغبتكم في التبرُّع للمشاريع والأعمال الخيرية أو رغبتكم في الاطلاع على ما يستجد من المشاريع والأعمال الخيرية التي تقوم بها الجمعية، حيث تساعدنا هذه البيانات في التواصل معك، والإجابة عن استفساراتك، وتنفيذ طلباتك قدر الإمكان.",
      "لا نقوم بمشاركة هذه البيانات مع أطراف خارجية إلا إذا كانت هذه الجهات لازمة في عملية استكمال طلبك، ما لم يكن ذلك في إطار بيانات جماعية تُستخدم للأغراض الإحصائية والأبحاث، دون اشتمالها على أية بيانات من الممكن استخدامها للتعريف بك.",
      "في الحالات الطبيعية يتم التعامل مع البيانات والبيانات بصورة آلية (إلكترونية) من خلال التطبيقات والبرامج المحددة لذلك، دون أن يستلزم ذلك مشاركة الموظفين أو اطلاعهم على تلك البيانات. وفي حالات استثنائية (كالتحقيقات والقضايا) قد يطّلِع عليها موظفو الجهات الرقابية أو من يلزم اطلاعه على ذلك؛ خضوعًا لأحكام القانون وأوامر الجهات القضائية.",
      "تنطبق سياسة الخصوصية هذه على كافة الخدمات والتعاملات التي يتم إجراؤها على الموقع إلا في الحالات التي يتم فيها النص على خدمات أو تعاملات ذات خصوصية؛ فإنه يكون لها سياسة خصوصية منفصلة، وغير مدمجة بسياسة الخصوصية هذه.",
      "على الرغم من ذلك قد يحتوي الموقع على روابط لمواقع إلكترونية أخرى تقع خارج سيطرتنا، ولا تغطيها سياسة الخصوصية هذه، في حال قمت بالوصول إلى مواقع أخرى من خلال استخدام الروابط المتاحة على موقعنا؛ فإنك ستخضع لسياسة الخصوصية المتعلِّقة بهذه المواقع، والتي قد تختلف عن سياسة الموقع؛ مما يتطلب منك قراءة سياسة الخصوصية المتعلِّقة بتلك المواقع.",
      "هذه البوابة قد تحتوي على روابط إلكترونية لمواقع أو بوابات قد تستخدم طرقًا لحماية البيانات وخصوصياتها تختلف عن الطرق المستخدمة لدينا، ونحن غير مسؤولين عن محتويات وطرق خصوصيات المواقع الأخرى التي لا تقع تحت استضافة موقع المركز وتتولى جهاتها مسؤولية حمايتها، وننصحك بالرجوع إلى إشعارات الخصوصية الخاصة بتلك المواقع.",
      "في كل الأحوال لن نقوم بالبيع أو التأجير أو المتاجرة ببياناتك أو بياناتك لمصلحة أي طرف ثالث خارج هذا الموقع. وسنحافظ في كافة الأوقات على خصوصية كافة بياناتك الشخصية التي نتحصل عليها وسريتها.",
      "نظرًا للتطور الهائل في مجال التقنية، والتغيُّر في نطاق القوانين المتعلقة بالمجال الإلكتروني، فالموقع يحتفظ بالحق في تعديل بنود سياسة الخصوصية هذه وشروطها في أي وقت يراه ملائمًا، ويتم تنفيذ التعديلات على هذه الصفحة، ويتم إخطاركم في حالة إجراء أية تعديلات ذات تأثير.",
      "للحفاظ على بياناتك الشخصية، يتم تأمين التخزين الإلكتروني والبيانات الشخصية المرسلة باستخدام التقنيات الأمنية المناسبة.",
      "يمكنك الاتصال بنا دائمًا للإجابة عن استفساراتك بخصوص هذه السياسة من خلال وحدة تقنية المعلومات حسب بيانات التواصل التالية:",
    ],
    contact: [
      "جمعية تكافل لرعاية الايتام – المدينة المنورة",
      "ص.ب ...............",
      "الرياض ..................",
      "المملكة العربية السعودية",
      "البريد الالكتروني  .........................",
      "هاتف  ........................",
      "فاكس  ........................",
    ],
  },
  {
    title: "المادة السابعة",
    content:
      "هذه السياسة جزء من سياسات الحوكمة في الجمعية ومكملة لها ويجب ألا تتعارض مع قواعد الحوكمة والأنظمة والتعليمات الصادرة من المركز والجهات الرسمية ذات الصلة وتعتمد هذه اللائحة من المجلس ويسري العمل بها من تاريخ اعتمدها.",
    items: [],
    contact: [],
  },
];
